import { configureStore } from "@reduxjs/toolkit";
import createRootReducer from "./rootReducer";

export default function createStore() {
  return configureStore({
    reducer: createRootReducer(),
    middleware: (getDefaultMiddleware) => [...getDefaultMiddleware()],
  });
}
